import { CasinoSharp } from "@mui/icons-material";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BESS_URL;

// 1. BESS Sizing (requires FormData)
export const runBessTask = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${process.env.REACT_APP_BESS_URL}/api/tasks/run`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("runBessTask error:", err.response?.data || err.message);
        throw err;
    }
};

// 2. ECOS Operation (POST, optional payload if needed)
export const runEcosOp = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${BASE_URL}/api/tasks/ecos-op`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("runEcosOp error:", err.response?.data || err.message);
        throw err;
    }
};

// 3. SOH Data (GET)
export const getSOH = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${BASE_URL}/api/tasks/soh`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("getSOH error:", err.response?.data || err.message);
        throw err;
    }
};

export const progress = async (task_id) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${BASE_URL}/test/progress/${task_id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (err) {
        console.error("Progress fetch error:", err);
        throw err;
    }
};

export const plot_data = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${process.env.REACT_APP_BESS_URL}/api/tasks/plot_data`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("plot_data error:", err.response?.data || err.message);
        throw err;
    }
};

export const daily_maximum = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${process.env.REACT_APP_BESS_URL}/api/tasks/daily_maximum`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("daily_maximum error:", err.response?.data || err.message);
        throw err;
    }
};

export const average_curve = async (formDataObj) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(`${process.env.REACT_APP_BESS_URL}/api/tasks/average_curve`, formDataObj, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (err) {
        console.error("average_curve error:", err.response?.data || err.message);
        throw err;
    }
};

export const load_factor = async (formDataObj, params) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.post(
            `${process.env.REACT_APP_BESS_URL}/api/tasks/load_factor`,
            formDataObj,
            {
                params,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        console.error("load_factor error:", err.response?.data || err.message);
        throw err;
    }
};